import { toast } from "react-toastify";

export const commonToast = (type, message) => {
    toast[type](message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 5000,
    });
}